<template>
    <!-- Footer -->
    <footer class="footer">
        <div class="footer-top ">
            <div class="container">

                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <div class="row">
                            <div class="col-xs-12 col-sm-4 col-md-5 col-lg-5 text-center">
                                <div class="footer-bottom-logo">
                                <router-link to="/" class="menu-logo">
                                    <img src="@/assets/talento_agv/img/AV_Logo_NEW_Purple_RGB_800.png" class="img-fluid" style="width: 100px;" alt="Logo">
                                </router-link>
                                <p style="margin-top:-10px">
                                    Av. Felipe Pardo y Aliaga 652. Int. 1201 <br>
                                    San Isidro, Lima
                                </p>
                                <ul class="redes_sociales_footer" style="margin-top:-10px; justify-content: center">
                                    <li>
                                        <a href="https://www.facebook.com/TrabajaEnAgrovisionPeru" target="_blank"><i class="fa-brands fa-facebook-f"
                                                aria-hidden="true"></i></a>
                                    </li>
                                    <li>
                                        <a href="https://www.tiktok.com/@agrovision.peru" target="_blank"><i class="fa-brands fa-tiktok"
                                                aria-hidden="true"></i></a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/agrovisionperu/;" target="_blank"><i class="fa-brands fa-instagram"
                                                aria-hidden="true"></i></a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/agrovisionperu/mycompany/" target="_blank"><i class="fa-brands fa-linkedin"
                                                aria-hidden="true"></i></a>
                                    </li>
                                </ul>
                            </div>
                            </div>
                            <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                <div class="footer-widget footer-menu">
                                    <h2 class="footer-title">Enlaces</h2>
                                    <ul>
                                        <li><router-link to="/"><i class="fas fa-angle-right me-1"></i>Inicio</router-link></li>
                                        <li><router-link to="/nuestra_cultura"><i class="fas fa-angle-right me-1"></i>Nuestra Cultura</router-link></li>
                                        <!-- <li><router-link to="/nuestros_colaboradores"><i class="fas fa-angle-right me-1"></i>Nuestros Colaboradores</router-link></li> -->
                                        <li><router-link to="/young_talent"><i class="fas fa-angle-right me-1"></i>Programa Young Talent</router-link></li>
                                        <li><router-link to="/escuela_corporativa"><i class="fas fa-angle-right me-1"></i>Escuela Corporativa</router-link></li>
                                        <!-- <li><router-link to="/register"><i class="fas fa-angle-right me-1"></i>Register</router-link></li>
                                        <li><router-link to="/forgot-password"><i class="fas fa-angle-right me-1"></i>Forgot
                                                Password</router-link></li> -->
                                    </ul>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3">
                                <div class="footer-widget footer-menu">
                                    <h2 class="footer-title">Acceso al Sistema</h2>
                                    <ul>
                                        <li><router-link to="/crear_cuenta"><i class="fas fa-angle-right me-1"></i>Crear Cuenta</router-link></li>
                                        <li><router-link to="/login"><i class="fas fa-angle-right me-1"></i>Ingresar</router-link></li>
                                        <!-- <li><a href="javascript:void(0);"><i class="fas fa-angle-right me-1"></i>Job
                                                Packages</a></li> -->
                                        <!-- <li><a href="javascript:void(0);"><i class="fas fa-angle-right me-1"></i>Jobs
                                                Featured</a></li>
                                        <li><a href="javascript:void(0);"><i class="fas fa-angle-right me-1"></i>Post A
                                                Job</a></li> -->
                                    </ul>
                                </div>
                            </div>
                            <!-- <div class="col-xl-4 col-md-6">
                                <div class="footer-widget footer-menu">
                                    <h2 class="footer-title">Contacta con Nosotros</h2>
                                    <ul>
                                        <li><router-link to="/"><i class="fas fa-angle-right me-1"></i>Preguntas Frecuentes</router-link></li>
                                        <li><router-link to="/freelancer/freelancer-chats"><i class="fas fa-angle-right me-1">Whatsapp</i></router-link>
                                        </li>
                                        <li><router-link to="/freelancer/freelancer-chats"><i
                                                    class="fas fa-angle-right me-1"></i>Reviews</router-link></li>
                                        <li><router-link to="/privacy-policy"><i class="fas fa-angle-right me-1"></i>Privacy
                                                Policy</router-link></li>
                                        <li><router-link to="/term-condition"><i class="fas fa-angle-right me-1"></i>Terms of
                                                use</router-link></li>
                                    </ul>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Footer Top -->

        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <div class="container">

                <!-- Copyright -->
                <div class="copyright">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="copyright-text text-center">
                                <p class="mb-0">Copyright {{ new Date().getFullYear() }} &copy; Agrovision. Todos los derechos reservados.</p>
                            </div>
                            <!-- <p class="right">Aplicaciones de Software &lt;/&gt;</p> -->
                        </div>
                    </div>
                </div>
                <!-- /Copyright -->
            </div>
        </div>
        <!-- /Footer Bottom -->
    </footer>
    <!-- /Footer -->
</template>

<style>
@media(max-width:768px){
    .redes_sociales_footer{
        justify-content: start !important;
    }
}
</style>